import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/lib/cart";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Products from "@/pages/admin/Products";
import Orders from "@/pages/admin/Orders";
import Bookings from "@/pages/admin/Bookings";
import Customers from "@/pages/admin/Customers";
import CustomerDetail from "@/pages/admin/CustomerDetail";
import InvoicePage from "@/pages/admin/InvoicePage";
import Settings from "@/pages/admin/Settings";
import Shop from "@/pages/shop/Shop";
import Cart from "@/pages/shop/Cart";
import CartReview from "@/pages/shop/CartReview";
import ProductPage from "@/pages/shop/ProductPage";
import ShopSuccess from "@/pages/shop/Success";
import CustomerLogin from "@/pages/customer/Login";
import CustomerAccount from "@/pages/customer/Account";
import CustomerInvoice from "@/pages/customer/InvoiceView";

const RequireAuth = ({ children }) =>
  localStorage.getItem("al_token") ? children : <Navigate to="/admin/login" replace />;

const RequireCustomer = ({ children }) =>
  localStorage.getItem("alc_token") ? children : <Navigate to="/account/login" replace />;

const RedirectExternal = ({ to }) => {
  useEffect(() => { window.location.replace(to); }, [to]);
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col items-center justify-center gap-4" data-testid="redirect-page">
      <p className="text-xs tracking-[0.3em] uppercase text-[#9E7B3A]">Redirecting…</p>
      <a href={to} data-testid="redirect-manual-link"
        className="text-sm text-[#4A4A4A] underline hover:text-[#9E7B3A] transition-colors duration-300">
        Continue to australianluxe.org
      </a>
    </div>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop/peppers" element={<RedirectExternal to="https://australianluxe.org" />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/product/:id" element={<ProductPage />} />
          <Route path="/shop/cart" element={<CartReview />} />
          <Route path="/shop/checkout" element={<Cart />} />
          <Route path="/shop/success" element={<ShopSuccess />} />
          <Route path="/account/login" element={<CustomerLogin />} />
          <Route path="/account" element={<RequireCustomer><CustomerAccount /></RequireCustomer>} />
          <Route path="/account/invoice/:orderNumber" element={<RequireCustomer><CustomerInvoice /></RequireCustomer>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/orders/:id/invoice" element={<RequireAuth><InvoicePage /></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
            <Route index element={<Dashboard />} />
            <Route path="products" element={<Products />} />
            <Route path="orders" element={<Orders />} />
            <Route path="bookings" element={<Bookings />} />
            <Route path="customers" element={<Customers />} />
            <Route path="customers/:id" element={<CustomerDetail />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </CartProvider>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}
